import { ScriptCommands } from '../../types/dashboard';
import { queryLogAwsCliInstallScript } from '../commands';

export const staticCommandsDataMYSQL: ScriptCommands = {
  saveSchemaToFile: [
    {
      commands: [
        'mysqldump --single-transaction --set-gtid-purged=off --host=<database_host> --user=<database_user> --port=<database_port> --no-data -p <database_name> > <output_file>.sql',
      ],
      title: 'Save MySQL Schema to File',
      description: '',
    },
  ],
  saveSchemaInstallScript: [
    {
      commands: ['mysqldump --version'],
      title: 'Verify installation of mysqldump',
      description: '',
    },
  ],
  saveSchemaDownloadScript: [
    {
      commands: ['cd mysql'],
      title: 'Move to mysql directory',
      description: '',
    },
    {
      commands: [
        'curl -sSL https://install.python-poetry.org | python3 -',
        'poetry shell',
        'poetry install',
      ],
      title: 'Activate virtual env',
      description: '',
    },
    {
      commands: ['exsch --db_name <db_name> -h <host> -p <port> -u <db_user>'],
      title: 'Run script',
      description: '',
    },
  ],
  createQueryLogSection1: [
    {
      commands: [
        "mysql -u <username> -p <database_name> -e \"SET SESSION sql_log_bin = 0; UPDATE performance_schema.setup_consumers SET ENABLED = 'YES' WHERE NAME = 'events_statements_history_long'; UPDATE performance_schema.setup_instruments SET ENABLED = 'YES' WHERE NAME LIKE 'statement/%';\"",
      ],
      title: 'Enable Query Monitoring',
      description:
        'Run this command to enable performance schema monitoring. This configures query tracking for the connected database.',
    },
    {
      commands: [
        "mysql -u <username> -p <database_name> -e \"UPDATE performance_schema.setup_objects SET ENABLED = 'YES' WHERE OBJECT_TYPE = 'TABLE' AND OBJECT_SCHEMA = '<database_name>'; FLUSH STATUS;\"",
      ],
      title: 'Configure Performance Monitoring',
      description:
        'Execute this command to configure performance schema to monitor database objects.',
    },
  ],
  createQueryLogSection2: [
    {
      commands: [
        // eslint-disable-next-line
        `mysql -u <username> -p <database_name> -e 
        "SELECT 
            CASE 
                WHEN e.timer_start > 1000000000000000 
                THEN DATE_FORMAT(FROM_UNIXTIME(e.timer_start/1000000000000), '%Y-%m-%d %H:%i:%s') 
                ELSE DATE_FORMAT(NOW(), '%Y-%m-%d %H:%i:%s') 
            END AS event_timestamp,
            ROUND(e.timer_wait/1000000000, 3) AS execution_time_ms,
            REPLACE(REPLACE(REPLACE(
                SUBSTRING(e.sql_text, 1, 1000),
                CHAR(9), ' '
            ), CHAR(13), ' '), CHAR(10), ' ') AS sql_text
        FROM performance_schema.events_statements_history_long e
        LEFT JOIN performance_schema.threads t ON e.thread_id = t.thread_id
        WHERE e.current_schema = 'TestDB'
            AND e.timer_start > 0
            AND e.sql_text IS NOT NULL
            AND e.sql_text != ''
        ORDER BY e.timer_start DESC
        LIMIT 1000;" --batch --raw > '<output_file>.csv'`,
      ],
      title: 'Extract Query Performance Data',
      description:
        'Use this command to extract detailed query performance data from MySQL Performance Schema into a CSV file.',
    },
    {
      commands: [
        "mysql -u <username> -p <database_name> -e \"UPDATE performance_schema.setup_objects SET ENABLED = 'NO' WHERE OBJECT_TYPE = 'TABLE' AND OBJECT_SCHEMA = '<database_name>';\"",
      ],
      title: 'Stop Query Monitoring',
      description:
        'Run this command to stop query performance monitoring.',
    },
    {
      commands: [
        "mysql -u <username> -p <database_name> -e \"UPDATE performance_schema.setup_objects SET ENABLED = 'NO' WHERE OBJECT_TYPE = 'TABLE' AND OBJECT_SCHEMA = '<database_name>'; UPDATE performance_schema.setup_consumers SET ENABLED = 'NO' WHERE NAME = 'events_statements_history_long'; FLUSH STATUS;\"",
      ],
      title: 'Clean Up Query Logging Configuration',
      description:
        'Execute this command to safely stop query monitoring and reset performance schema settings.',
    },
  ],
  exportDatabase: [
    {
      commands: [
        '$ aws s3 cp myfolder s3://mybucket/myfolder --recursive',
        'upload: myfolder/file1.txt to s3://mybucket/myfolder/file1.txt',
        'upload: myfolder/subfolder/file.txt to s3://mybucket/myfolder/subfolder/file1.txt',
      ],
      title: 'Copy Files to S3 Bucket',
      description: 'Command to copy files to an S3 bucket recursively',
    },
    {
      commands: [
        '$ aws s3 sync myfolder s3://mybucket/myfolder --exclude # .tmp',
        'upload: myfolder/newfile.txt to s3://mybucket/myfolder/newfile.txt',
      ],
      title: 'Sync Files to S3 Bucket',
      description:
        'Command to sync files to an S3 bucket, excluding temporary files',
    },
  ],
  downloadScript: [
    {
      commands: ['sudo apt install mysql-client'],
      title: 'Install mysql server on linux',
      description: '',
    },
    {
      commands: [
        'sudo apt-get install unzip',
        'unzip script.zip -d <destination_folder>',
      ],
      title: 'Extract package',
      description: 'Extract the downloaded package',
    },
    {
      commands: ['cd mysql'],
      title: 'Move to mysql directory',
      description: '',
    },
    {
      commands: [
        'curl -sSL https://install.python-poetry.org | python3 -',
        'poetry install',
        'poetry shell',
      ],
      title: 'Activate virtual env',
      description: '',
    },
    {
      commands: [
        'exdbd --db_name <database_name> --db_schema <schema_name> --db_host <host_address> --db_port <port> --db_user <database_user>',
      ],
      title: 'Run script',
      description: '',
    },
  ],
  settingUpTheSystemCommandSection1: [
    {
      commands: ['python --version', 'pip --version'],
      title: '',
      description: '',
    },
  ],
  settingUpTheSystemCommandSection2: [
    {
      commands: ['pip install pipenv --user'],
      title: '',
      description: '',
    },
  ],
  settingUpTheSystemCommandSection3: [
    {
      commands: ['mysqldump --version'],
      title: '',
      description: '',
    },
  ],
  exportDataAndDeidentificationScript: [
    {
      commands: [
        'sudo apt-get install unzip',
        'unzip script.zip -d <destination_folder>',
      ],
      title: 'Extract the package',
      description: '',
    },
    {
      commands: ['cd export_and_deidentify'],
      title: 'Move to export and deidentification directory',
      description: '',
    },
    {
      commands: [
        'curl -sSL https://install.python-poetry.org | python3 -',
        'poetry shell',
        'poetry install',
      ],
      title: 'Activate virtual env',
      description: '',
    },
    {
      commands: [
        'exdbd --db_name <database_name> --db_schema <schema_name> --db_host <database_host> --db_port <database_port> --db_user <database_username>',
      ],
      title: 'Run script',
      description: 'Execute the export and deidentification script for MySQL',
    },
  ],
  shareDeidentifiedFileScript: [
    {
      commands: [
        '$ aws s3 cp myfolder s3://mybucket/myfolder --recursive',
        'upload: myfolder/file1.txt to s3://mybucket/myfolder/file1.txt',
        'upload: myfolder/subfolder/file.txt to s3://mybucket/myfolder/subfolder/file1.txt',
      ],
      title: 'Upload Files from S3 Bucket',
      description: 'Command to Upload files from an S3 bucket',
    },
  ],
  queryLogExtractionSetupCommand1: [
    {
      commands: ['poetry --version'],
      title: 'Verify Installation of Poetry',
      description: '',
    },
  ],
  queryLogExtractionSetupCommand2: [
    {
      commands: ['python --version'],
      title: 'Verify Python Installation',
      description: '',
    },
  ],
  exportQueryLogsScript: [
    {
      commands: ['cd export_query_logs'],
      title: 'Move to export query logs directory',
      description: '',
    },
    {
      commands: ['poetry shell'],
      title: 'Activate virtual env',
      description: 'Note: Run "poetry install" only once during initial setup if dependencies are not already installed.',
    },
    {
      commands: [
        'export-query-logs --db-type mysql --host <DB_HOSTNAME> --port <DB_PORT> --user <DB_USERNAME> --password <DB_PASSWORD> --database <DB_NAME> --mode export --duration <DURATION_IN_HOURS(DEFAULT: 24)>',
      ],
      title: 'Run script (Export Mode)',
      description: 'Runs the script in export mode: enables logging, waits for the specified duration, then disables logging and exports the logs.',
    },
  ],
  enableQueryLogsScript: [
    {
      commands: ['cd export_query_logs'],
      title: 'Move to export query logs directory',
      description: '',
    },
    {
      commands: ['poetry shell'],
      title: 'Activate virtual env',
      description: 'Note: Run "poetry install" only once during initial setup if dependencies are not already installed.',
    },
    {
      commands: [
        'export-query-logs --db-type mysql --host <DB_HOSTNAME> --port <DB_PORT> --user <DB_USERNAME> --password <DB_PASSWORD> --database <DB_NAME> --mode enable',
      ],
      title: 'Enable query logging (Step 1)',
      description: 'Enables MySQL slow query log with 0-second threshold to capture all queries. Run this command once to start logging. The script will exit immediately after enabling logging.',
    },
  ],
  disableQueryLogsScript: [
    {
      commands: ['cd export_query_logs'],
      title: 'Move to export query logs directory',
      description: '',
    },
    {
      commands: ['poetry shell'],
      title: 'Activate virtual env',
      description: 'Note: Run "poetry install" only once during initial setup if dependencies are not already installed.',
    },
    {
      commands: [
        'export-query-logs --db-type mysql --host <DB_HOSTNAME> --port <DB_PORT> --user <DB_USERNAME> --password <DB_PASSWORD> --database <DB_NAME> --mode disable --output-dir <OUTPUT_DIRECTORY>',
      ],
      title: 'Disable query logging and export (Step 2)',
      description: 'Disables MySQL slow query log and exports the captured logs to a CSV file. Run this command after some time to stop logging and retrieve the logs.',
    },
  ],
  queryLogAwsCliInstallScript,
};
